export default __webpack_public_path__ + "static/media/logo-light-full.3f0374df.svg";